export enum AssetCodeAdditionalAttribute {
  OpenSide = 'open_side',
  DoubleDoor = 'double_door',
  HardTop = 'hard_top',
  SoftTop = 'soft_top',
}
